import React from "react";
import withIconComponent from "../../../withIconComponent";

var SquareDelete10 = function SquareDelete10() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h22v22H1z",
    stroke: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12H7",
    stroke: "#FF6400",
    "data-color": "color-2"
  }));
};

export default withIconComponent("NucleoSmallUserInterfaceSquareDelete10", false)(SquareDelete10);